module.exports = __webpack_public_path__ + "static/media/energy-graph.4bc50270.png";